export const PERFORMANCE_TIMEOUT = 100;
